module.exports = __webpack_public_path__ + "media/assets/images/layout/img-feature-bg-3-891440c6581e572429c1b4d530c22e59.png";